import React, { useState } from 'react';

const AddSpecificationForm = ({ onSpecsChange, initialSpecifications = [], initialCustomSpecs = [], onClose }) => {
  const [specifications, setSpecifications] = useState(initialSpecifications.length > 0 ? initialSpecifications : [{
    rating: '',
    voltageRatio: '',
    winding: '',
    losses: '',
    tapChanger: '',
    terminal: '',
    qty: ''
  }]);

  const [customSpecs, setCustomSpecs] = useState(initialCustomSpecs);

  // Standard specification handlers
  const handleSpecChange = (index, field, value) => {
    const newSpecs = [...specifications];
    newSpecs[index][field] = value;
    setSpecifications(newSpecs);
    onSpecsChange(newSpecs, customSpecs);
  };

//   const addMoreSpec = () => {
//     const newSpecs = [...specifications, {
//       rating: '',
//       voltageRatio: '',
//       winding: '',
//       losses: '',
//       tapChanger: '',
//       terminal: '',
//       qty: ''
//     }];
//     setSpecifications(newSpecs);
//     onSpecsChange(newSpecs, customSpecs);
//   };

//   const removeSpec = (index) => {
//     const newSpecs = specifications.filter((_, i) => i !== index);
//     setSpecifications(newSpecs);
//     onSpecsChange(newSpecs, customSpecs);
//   };

  // Custom specification handlers
  const handleCustomSpecChange = (index, field, value) => {
    const newSpecs = [...customSpecs];
    newSpecs[index][field] = value;
    setCustomSpecs(newSpecs);
    onSpecsChange(specifications, newSpecs);
  };

  const addCustomSpecField = () => {
    const newSpecs = [...customSpecs, { label: '', value: '' }];
    setCustomSpecs(newSpecs);
    onSpecsChange(specifications, newSpecs);
  };

  const removeCustomSpec = (index) => {
    const newSpecs = customSpecs.filter((_, i) => i !== index);
    setCustomSpecs(newSpecs);
    onSpecsChange(specifications, newSpecs);
  };

  return (
    <div className="specification-form">
      <h4>Standard Specifications</h4>
      {specifications.map((spec, index) => (
        <div key={`standard-${index}`} className="spec-group">
          <div className="form-group">
            <label>Rating:</label>
            <input
              type="text"
              value={spec.rating}
              onChange={(e) => handleSpecChange(index, 'rating', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Voltage Ratio:</label>
            <input
              type="text"
              value={spec.voltageRatio}
              onChange={(e) => handleSpecChange(index, 'voltageRatio', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Winding:</label>
            <input
              type="text"
              value={spec.winding}
              onChange={(e) => handleSpecChange(index, 'winding', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Losses:</label>
            <input
              type="text"
              value={spec.losses}
              onChange={(e) => handleSpecChange(index, 'losses', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Tap changer:</label>
            <input
              type="text"
              value={spec.tapChanger}
              onChange={(e) => handleSpecChange(index, 'tapChanger', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Terminal:</label>
            <input
              type="text"
              value={spec.terminal}
              onChange={(e) => handleSpecChange(index, 'terminal', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Qty:</label>
            <input
              type="number"
              min="0"
              value={spec.qty}
              onChange={(e) => handleSpecChange(index, 'qty', e.target.value)}
            />
          </div>
          {/* {specifications.length > 1 && (
            <button 
              type="button" 
              className="btn remove-spec-button" 
              onClick={() => removeSpec(index)}
            >
              Remove
            </button>
          )} */}
        </div>
      ))}
      {/* <button 
        type="button" 
        className="btn add-more-button" 
        onClick={addMoreSpec}
      >
        Add More Standard Specs
      </button> */}

      <h4>Custom Specifications</h4>
      {customSpecs.map((spec, index) => (
        <div key={`custom-${index}`} className="custom-spec-group">
          <div className="form-group">
            <label>Field Name:</label>
            <input
              type="text"
              value={spec.label}
              onChange={(e) => handleCustomSpecChange(index, 'label', e.target.value)}
              placeholder="Enter field name"
            />
          </div>
          <div className="form-group">
            <label>Value:</label>
            <input
              type="text"
              value={spec.value}
              onChange={(e) => handleCustomSpecChange(index, 'value', e.target.value)}
              placeholder="Enter value"
            />
          </div>
          <button 
            type="button" 
            className="btn remove-spec-button" 
            onClick={() => removeCustomSpec(index)}
          >
            Remove
          </button>
        </div>
      ))}
      <button 
        type="button" 
        className="btn add-more-button" 
        onClick={addCustomSpecField}
      >
        Add Custom Field
      </button>

      <button 
        type="button" 
        className="btn cancel-spec-button" 
        onClick={onClose}
      >
        Done
      </button>
    </div>
  );
};

export default AddSpecificationForm;
